import { Controller } from "stimulus"

export default class extends Controller {
  static targets = [ "field" ]

  toggle(e) {
    this.element.classList.toggle("disabled")
    this.fieldTargets.forEach(el => { el.disabled = !e.currentTarget.checked })
  }
}
